import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { combineClassNames } from 'core/css';
import {
  fetchFeaturedContentUrls,
  fetchFeaturedContentTemplate,
} from '../../../api/fetchFeaturedContent';

const FeaturedContent = ({ modelInfo, className, type }) => {
  const [template, setTemplate] = useState(null);

  const { enableFeaturedBrandPromo, enableFeaturedSubscription } = modelInfo;
  const enableFeaturedContent =
    type === 'promo' ? enableFeaturedBrandPromo : enableFeaturedSubscription;

  useEffect(() => {
    const url = get(modelInfo, 'featuredContentUrl');
    let featuredTemplateUrl;
    if (enableFeaturedContent) {
      fetchFeaturedContentUrls(url, modelInfo).then((urls) => {
        switch (type) {
          case 'promo':
            featuredTemplateUrl = get(urls, 'featuredPromoUrl', '');
            break;
          case 'subscription':
            featuredTemplateUrl = get(urls, 'featuredSubscriptionUrl', '');
            break;
        }

        if (enableFeaturedContent && featuredTemplateUrl) {
          fetchFeaturedContentTemplate(
            featuredTemplateUrl,
            modelInfo,
            type
          ).then((template) => {
            setTemplate(template);
          });
        }
      });
    }
  }, []);

  return (
    <>
      {template ? (
        <div
          className={combineClassNames('featured-content-container', className)}
          dangerouslySetInnerHTML={{ __html: template }}
        />
      ) : null}
    </>
  );
};

FeaturedContent.defaultProps = {
  type: 'promo',
};

FeaturedContent.propTypes = {
  type: PropTypes.string,
};

export default FeaturedContent;
